import styled from "@emotion/styled";

export const UnProtectedContent = styled.div`
	min-height: 0; //calc(100vh - 51px);
`;
